import React from "react";
import styled from 'styled-components';
import { navigate } from "@reach/router";

const RAZAS = {
  "Bio-Cibernéticos": "#3E4B57",
  "Brujos": "#E88C2A",
  "Dragones": "#6a0f6f",
  "Elfos": "#EBE7A4",
  "Hombres Bestia": "#5CB896",
  "Humanos": "#3959A8",
  "Licántropos": "#7A9968",
  "Vampiros": "#AD1F1F",
}

const PreRaceButton = styled.button`
  font-size: 1em;
  margin: 0.5em;
  padding: 0.5em 1.5em;
  width: 170px;
  border-radius: 5px;
  background-color: #1b1b1b;

  color: ${(props) => props.buttonColor};
  font-weight: 500;
  border: none;

  &:hover {
    background-color: #404040;
  }
`;

//${(props) => props.buttonColor};

export default ({raza}) => {
  return <PreRaceButton
    buttonColor={getColor(raza)}
    onClick={() => navigate(getLink(raza))}
  >
    {raza}
  </PreRaceButton>
}

const getLink = (raza) => `/articulo/${raza.toLowerCase().replace(' ', '-')}`
const getColor = (raza) => RAZAS[raza]

// function hexToRgb(hex) {
//   if (hex.substring(0, 1) === '#') hex = hex.substring(1)
//   var bigint = parseInt(hex, 16);
//   var r = (bigint >> 16) & 255;
//   var g = (bigint >> 8) & 255;
//   var b = bigint & 255;

//   return r + "," + g + "," + b;
// }